import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorType } from '../../../../@types/model/masterData/pumpingStation/motorType';

export default class MasterDataPumpingStationMotorTypeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_TYPES', resolve => (pumps : Array<IPumpingStationMotorType>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_TYPES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}